import { render } from "./PaymentDocumentCreationConfirmationModal.vue?vue&type=template&id=6c58fec7"
import script from "./PaymentDocumentCreationConfirmationModal.vue?vue&type=script&lang=js"
export * from "./PaymentDocumentCreationConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__